import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { OverflowMenuButton } from "../../../../common/overflow-menu-button/overflow-menu-button";

@Component({
  selector: "modify-l2vpn-fw-button",
  templateUrl: "modify-l2vpn-fw-button.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTooltipModule, OverflowMenuButton, TranslatePipe],
})
export class ModifyL2vpnFwButton {
  readonly subscription = input.required<{ product: { tag: string }; dirty: boolean }>();
  readonly isInfrastructureDelegate = input.required<boolean>();

  protected clicked = output<string>();

  protected selfServiceEnabled = computed(() => !this.subscription().dirty);

  protected selectItem = (item: string) => this.clicked.emit(item);
}
